// extracted by mini-css-extract-plugin
export default {"container":"Education_container__H4B+J"};